var map = {
	"./": [
		525
	],
	"./en": [
		1188,
		6
	],
	"./en.js": [
		1188,
		6
	],
	"./id": [
		1189,
		7
	],
	"./id.js": [
		1189,
		7
	],
	"./index": [
		525
	],
	"./index.js": [
		525
	],
	"./ja": [
		1190,
		8
	],
	"./ja.js": [
		1190,
		8
	],
	"./ko": [
		1191,
		9
	],
	"./ko.js": [
		1191,
		9
	],
	"./th": [
		1192,
		10
	],
	"./th.js": [
		1192,
		10
	],
	"./vi": [
		1193,
		11
	],
	"./vi.js": [
		1193,
		11
	],
	"./zh": [
		1194,
		12
	],
	"./zh.js": [
		1194,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1195;
module.exports = webpackAsyncContext;